import { auth, db } from '../utils/firebase';
import { addDoc, collection, doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';


function makeConversationKey({ uid1, uid2, matchId }) {
  const pair = [uid1, uid2].sort().join('__');
  return matchId ? `${pair}__${matchId}` : pair;
}


export async function startOrGetConversation({ uid1, uid2, matchId, trailId }) {
  const id = makeConversationKey({ uid1, uid2, matchId });
  // const ref = doc(db, 'conversations', id);
  // const snap = await getDoc(ref);
  // if ( !auth.currentUser || !snap.exists()) {
  //   await setDoc(ref, {
  //     members: [uid1, uid2],
  //     match_id: matchId || null,
  //     trail_id: trailId || null,
  //     createdAt: serverTimestamp(),
  //   });
  // }
  await setDoc(doc(db, 'conversations', id), {
      members: [uid1, uid2],
      match_id: matchId || null,
      trail_id: trailId || null,
      createdAt: serverTimestamp(),
    })
  return id;
}

export async function sendMessage({ conversationId, text, senderId }) {
  if (!text?.trim()) return;
  const msgs = collection(db, 'conversations', conversationId, 'messages');
  await addDoc(msgs, { text: text.trim(), senderId, createdAt: serverTimestamp() });
}
